// extracted by mini-css-extract-plugin
export default {"calender":"Calendar_calender__WFi6B","gitCalender":"Calendar_gitCalender__L2tXI","stats":"Calendar_stats__s5VPN"};